"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authOrderContract = void 0;
const dbEnums_1 = require("@daymade/common-lib/dbEnums");
const dbJsonModels_1 = require("@daymade/common-lib/dbJsonModels");
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const draw_1 = require("../draw/draw");
const models_1 = require("../draw/drawOrder/models");
const payment_1 = require("../payment");
const models_2 = require("../subscription/models");
const models_3 = require("./models");
const c = (0, core_1.initContract)();
exports.authOrderContract = c.router({
    getOrderStatus: {
        method: 'GET',
        path: '/status/:order_id',
        responses: {
            200: zod_1.z.object({
                status: zod_1.z.string(),
            }),
            404: c.type(),
        },
    },
    getOrderDetailsByAdyenPaymentSession: {
        method: 'GET',
        path: '/details/adyen/:adyen_payment_session_id',
        responses: {
            200: zod_1.z.object({
                order: models_3.ZOrderSelect,
                drawOrder: models_1.ZDrawOrderSelect.nullable(),
                firstDraw: draw_1.ZDrawSelect.nullable(),
                drawSchedulePlans: zod_1.z
                    .object({
                    drawSchedule: draw_1.ZDrawScheduleSelect,
                    drawTypePlan: draw_1.ZDrawTypePlanSelect,
                })
                    .array()
                    .nullable(),
                subscription: models_2.ZSubscriptionSelect.nullable(),
                promoCode: zod_1.z.string().nullable(),
            }),
            404: c.type(),
        },
    },
    getOrderDetails: {
        method: 'GET',
        path: '/details/:order_id',
        responses: {
            200: zod_1.z.object({
                order: models_3.ZOrderSelect,
                drawOrder: models_1.ZDrawOrderSelect.nullable(),
                firstDraw: draw_1.ZDrawSelect.nullable(),
                drawSchedulePlans: zod_1.z
                    .object({
                    drawSchedule: draw_1.ZDrawScheduleSelect,
                    drawTypePlan: draw_1.ZDrawTypePlanSelect,
                })
                    .array()
                    .nullable(),
                subscription: models_2.ZSubscriptionSelect.nullable(),
                promoCode: zod_1.z.string().nullable(),
            }),
            404: c.type(),
        },
    },
    createOrder: {
        method: 'POST',
        path: '/create',
        responses: {
            200: models_3.ZCreateOrderResponse,
            400: zod_1.z.string(),
        },
        body: zod_1.z.object({
            purchasingAction: models_3.ZPurchasingAction,
            drawPurchase: zod_1.z
                .object({
                entries: zod_1.z.array(dbJsonModels_1.ZEntryLine),
                drawId: zod_1.z.number().optional(),
                drawTypeCode: zod_1.z.string(),
                drawSchedulePlans: zod_1.z
                    .object({
                    drawScheduleId: zod_1.z.coerce.number(),
                    drawTypePlanCode: zod_1.z.string(),
                    drawTypePlanSubcode: zod_1.z.string(),
                })
                    .array(),
            })
                .optional(),
            prizePurchase: zod_1.z
                .object({
                prizeTierId: zod_1.z.number(),
                prizeId: zod_1.z.number(),
                productId: zod_1.z.number().optional(),
                deliveryStreet: zod_1.z.string().optional(),
                deliveryCity: zod_1.z.string().optional(),
                deliveryPostcode: zod_1.z.string().optional(),
                emailAddress: zod_1.z.string().optional(),
                phoneNumber: zod_1.z.string().optional(),
                additionalInfoFromPlayer: zod_1.z
                    .record(zod_1.z.string(), zod_1.z.string())
                    .optional(),
            })
                .optional(),
            treePurchase: zod_1.z
                .object({
                action: zod_1.z.nativeEnum(dbEnums_1.TreeAction),
                quantity: zod_1.z.number(),
            })
                .optional(),
            tokenPurchase: zod_1.z
                .object({
                tokenAmount: zod_1.z.number(),
            })
                .optional(),
            paymentCurrency: payment_1.ZPaymentCurrency.optional(),
            expectedCost: zod_1.z.number().optional(),
            paymentMethod: payment_1.ZPaymentMethod.optional(),
            sourceFor3DS: zod_1.z.string().optional(),
            promoCode: zod_1.z.string().optional(),
            referralId: zod_1.z.string().optional(),
            utmParams: zod_1.z.record(zod_1.z.string(), zod_1.z.string()).nullish(),
            attributionParams: zod_1.z.record(zod_1.z.string(), zod_1.z.string()).nullish(),
        }),
    },
}, {
    pathPrefix: '/auth',
    strictStatusCodes: true,
    commonResponses: {
        401: c.type(),
        403: c.type(),
    },
});
//# sourceMappingURL=order.auth.contract.js.map